import { capitalize } from '@leverege/string-util';
import { contractStates } from '../../../constants';
import AliasEqualsSelector from '../AliasEqualsSelector';
import CalculatedContractStateEqualsComparator from './CalculatedContractStateEqualsComparator';
const options = Object.values(contractStates).map(value => ({
  name: capitalize(value),
  value
}));
export default AliasEqualsSelector.create(CalculatedContractStateEqualsComparator, options);